<template>
    <div class="text-center">
        <v-bottom-sheet v-model="sheetShown" persistent inset scrollable>
            <v-card>
                <!-- >>> Stepper -->
                <v-card-text class="mt-3" style="height:800px;">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-stepper v-model="formStepper" non-linear>
                                <!-- >>> Stepper: Header                     -->
                                <v-stepper-header style="position:relative;z-index:10000;">
                                    <v-stepper-step
                                        editable
                                        :rules="[ () => isValid_Stepper1 ]"
                                        step="1"
                                        @click="() => onClick_StepperHeader('1')">
                                        General Airport Information
                                    </v-stepper-step>

                                    <v-divider />

                                    <v-stepper-step
                                        editable
                                        :rules="[ () => isValid_Stepper2 ]"
                                        step="2"
                                        @click="() => onClick_StepperHeader('2')">
                                        Airport Contact
                                    </v-stepper-step>

                                    <v-divider />

                                    <v-stepper-step
                                        editable
                                        :rules="[ () => isValid_Stepper3 ]"
                                        step="3"
                                        @click="() => onClick_StepperHeader('3')">
                                        Slot Relevant Information
                                    </v-stepper-step>
                                </v-stepper-header>
                                <!-- <<< Stepper: Header                     -->


                                <!-- >>> Stepper: 1 - 'General Airport Information'        -->
                                <v-stepper-content ref="stepperContent1" class="pt-3" step="1">
                                    <!-- >>> Row - General Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>General Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-text-field
                                                        v-model="input_airportName"
                                                        :rules ="[
                                                            rules.req(input_airportName),
                                                        ]"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Airport Name <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_iataCode"
                                                        :rules ="[
                                                            rules.req(input_iataCode),
                                                        ]"
                                                        clearable>
                                                        <template v-slot:label>
                                                            IATA Code <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_icaoCode"
                                                        clearable>
                                                        <template v-slot:label>
                                                            ICAO Code <span style="color: red; font-size: 1.4rem;" />
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-select
                                                        v-model="input_country"
                                                        :rules ="[
                                                            rules.req(input_country),
                                                        ]"
                                                        :items="get_Countries"
                                                        item-value="id"
                                                        item-text="name">
                                                        <template v-slot:label>
                                                            Country <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_location"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Location <span style="color: red; font-size: 1.4rem;" />
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field
                                                            v-model="input_longitude"
                                                            clearable>
                                                            <template v-slot:label>
                                                                Longitude <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-text-field
                                                            v-model="input_latitude"
                                                            clearable>
                                                            <template v-slot:label>
                                                                Latitude <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="12">
                                                        <v-text-field
                                                            v-model="input_airportWebsite"
                                                            clearable>
                                                            <template v-slot:label>
                                                                Airport Website <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- >>> Row - General Information -->

                                    <!-- >>> Row - Time Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Time Information</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-text-field
                                                        v-model="input_timeZoneName"
                                                        clearable>
                                                        <template v-slot:label>
                                                            Time Zone Name <span style="color: red; font-size: 1.4rem;" />
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col style="display:flex; align-items:center;" cols="12" sm="2">
                                                    <div>Opening Hours (Mo - So)</div>
                                                </v-col>
                                                <v-col cols="12" sm="5">
                                                    <v-text-field
                                                        v-model="input_AirportOpenFrom"
                                                        prepend-icon="mdi-clock-time-four-outline"
                                                        type="time"
                                                        label="From" />
                                                </v-col>
                                                 <v-col cols="12" sm="5">
                                                    <v-text-field
                                                        v-model="input_AirportOpenTill"
                                                        prepend-icon="mdi-clock-time-four-outline"
                                                        type="time"
                                                        label="To" />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- >>> Row - Time Information -->
                                </v-stepper-content>
                                <!-- <<< Stepper: 1 - 'General Airport Information'        -->

                                <!-- >>> Stepper: 2 -  Airport Contact-->
                                <v-stepper-content ref="stepperContent2" class="pt-3" step="2">
                                <!-- >>> Row - New Airport Contact -->
                                        <v-row class="input-row">
                                            <v-col cols="12" sm="4">
                                                <h2>New Airport Contact</h2>
                                            </v-col>

                                            <v-col cols="12" sm="8">
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field
                                                            v-model="input_contactName"
                                                            clearable>
                                                            <template v-slot:label>
                                                                Name <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>

                                                    <v-col cols="12" sm="4">
                                                        <v-text-field
                                                            v-model="input_contactRole"
                                                            clearable>
                                                            <template v-slot:label>
                                                                Role <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>

                                                    <v-col cols="12" sm="4">
                                                        <v-text-field
                                                            v-model="input_contactEmail"
                                                            :rules ="[
                                                                rules.max(50, input_contactEmail),
                                                                rules.min(6, input_contactEmail),
                                                                rules.isEmailAddress(input_contactEmail)
                                                            ]"
                                                            clearable>
                                                            <template v-slot:label>
                                                                E-Mail <span style="color: red; font-size: 1.4rem;" />
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>

                                                    <v-col cols="12" sm="2">
                                                        <v-btn
                                                        block
                                                            style="margin-top:16px;"
                                                            color="primary"
                                                            @click="onValidate_AirportContact">
                                                            Add
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Row - New Airport Contact -->

                                        <!-- >>> Row - List of Airport Contacts -->
                                        <v-row class="input-row">
                                            <v-col cols="12" sm="4">
                                                <h2>List of Airport Contacts</h2>
                                            </v-col>

                                            <v-col cols="12" sm="8">
                                                <v-data-table
                                                    style="margin-bottom: 35px;margin-top:24px;"
                                                    :headers="headersAirportContact"
                                                    :items="input_airportContacts"
                                                    :disable-pagination="true"
                                                    :hide-default-footer="true"
                                                    sort-by="name"
                                                    :sort-desc="true"
                                                    class="elevation-1 data-table-custom-colors">
                                                    <!-- >>> Action:Column -->
                                                    <template v-slot:item.actions="{ item }">
                                                        <v-icon small class="mr-2" @click="onClick_updateOrDeleteAirportContactEntry(item, 'update')">
                                                            mdi-pencil
                                                        </v-icon>
                                                        <v-icon small @click="onClick_updateOrDeleteAirportContactEntry(item, 'delete')">
                                                            mdi-delete
                                                        </v-icon>
                                                    </template>
                                                    <!-- <<< Action:Column -->
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Row - List of Airport Contacts -->
                                    </v-stepper-content>
                                <!-- <<< Stepper: 2 -  Airport Contact-->

                                <!-- >>> Stepper: 3 - Slot Relevant Information-->
                                <v-stepper-content ref="stepperContent3" class="pt-3" step="3">
                                <!-- >>> Row - Slot Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Slot Information</h2>
                                        </v-col>
                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="5">
                                                    <v-select
                                                        v-model="input_AirportCoordinated"
                                                        :rules ="[
                                                            rules.req(input_AirportCoordinated.value === false ? 'flase' : input_AirportCoordinated.value),
                                                        ]"
                                                        :items="items_AirportCoordinated"
                                                        item-value="value"
                                                        item-text="text"
                                                        return-object
                                                        @change="onChange_airportCoordinated">
                                                        <template v-slot:label>
                                                            <p>
                                                            Airport Coordinated? <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                 <v-col cols="12" sm="5">
                                                    <v-select
                                                        v-model="input_AirportCoordinationLevel"
                                                        :rules ="[
                                                            rules.req(input_AirportCoordinated.value === false ? 'flase' : input_AirportCoordinationLevel),
                                                        ]"
                                                        :items="items_AirportCoordinationLevel"
                                                        item-value="value"
                                                        item-text="text"
                                                        :disabled="!input_AirportCoordinated.value"
                                                        return-object>
                                                        <template v-slot:label>
                                                            <p>
                                                            Coordination Level <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Slot Information -->


                                    <!-- >>> Row - New Slot Contact -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>New Slot Contact</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_slotName"
                                                        clearable
                                                        :disabled="!input_AirportCoordinated.value">
                                                        <template v-slot:label>
                                                            Name <span style="color: red; font-size: 1.4rem;" />
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="input_slotEmail"
                                                        clearable
                                                        :rules ="[
                                                            rules.max(50, input_slotEmail),
                                                            rules.min(6, input_slotEmail),
                                                            rules.isEmailAddress(input_slotEmail)
                                                        ]"
                                                        :disabled="!input_AirportCoordinated.value">
                                                        <template v-slot:label>
                                                            E-Mail <span style="color: red; font-size: 1.4rem;" />
                                                        </template>
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="2">
                                                    <v-btn
                                                    block
                                                        style="margin-top:16px;"
                                                        color="primary"
                                                        :disabled="!input_AirportCoordinated.value"
                                                        @click="onValidate_SlotContact">
                                                        Add
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - New Slot Contact -->

                                    <!-- >>> Row - List of Slot Contacts -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>List of Slot Contacts</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-data-table
                                                style="margin-bottom: 35px;margin-top:24px;"
                                                :headers="headersSlotContact"
                                                :items="input_slotContacts"
                                                :disable-pagination="true"
                                                :hide-default-footer="true"
                                                sort-by="name"
                                                :sort-desc="true"
                                                class="elevation-1 data-table-custom-colors">
                                                <!-- >>> Action:Column -->
                                                <template v-slot:item.actions="{ item }">
                                                    <v-icon small class="mr-2" @click="onClick_updateOrDeleteSlotContactEntry(item, 'update')">
                                                        mdi-pencil
                                                    </v-icon>
                                                    <v-icon small @click="onClick_updateOrDeleteSlotContactEntry(item, 'delete')">
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
                                                <!-- <<< Action:Column -->
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - List of Slot Contacts -->
                                </v-stepper-content>
                                <!-- <<< Stepper: 3 - Slot Relevant Information-->
                            </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>
                <!-- <<< Stepper -->


                <!-- >>> Actions -->
                <v-card-actions>
                    <v-spacer />

                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet">
                    Close
                    </v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onValidate_Form">
                    Save
                    </v-btn>
                </v-card-actions>
                <!-- <<< Actions -->
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';

    export default {
        name: 'BottomSheet',


        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean], // 'showSheet' itself
            editorMode: String, // 'update', 'create'
            airportsPrefillObject: Object

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                id: '',
                isSlotContactUpdateCase: false,
                isAirportContactUpdateCase: false,
                // >>> ------------------------------------ Input Fields General Information
                input_airportName: '',
                input_airportNameDE: '',
                input_iataCode: '',
                input_icaoCode: '',
                input_country: '',
                input_airportWebsite: '',
                input_timeZoneName: '',
                input_AirportOpenFrom: '',
                input_AirportOpenTill: '',
                input_longitude: null,
                input_latitude: null,
                input_location: '',
                input_locationDE: '',
                // >>> ------------------------------------ Input Fields Airport Contacts
                input_contactId: '',
                input_contactName: '',
                input_contactRole: '',
                input_contactEmail: '',
                input_airportContacts: [],
                // >>> ------------------------------------ Input Fields Slot Contacts
                input_AirportCoordinated: {
                        text: 'No',
                        value: false
                    },
                items_AirportCoordinated: [
                    {
                        text: 'Yes',
                        value: true
                    },
                    {
                        text: 'No',
                        value: false
                    }
                ],
                input_AirportCoordinationLevel: null,
                items_AirportCoordinationLevel: [
                    {
                        text: 'LEVEL 2',
                        value: 'LEVEL2'
                    },
                    {
                        text: 'LEVEL 3',
                        value: 'LEVEL3'
                    }
                ],
                input_slotId: null,
                input_slotName: '',
                input_slotEmail: '',
                input_slotContacts: [],
                // >>> ------------------------------------ Validation
                formStepper: 1,
                valid: false,
                isValid_Stepper1: true,
                isValid_Stepper2: true,
                isValid_Stepper3: true,
                activeStepper: '1',
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || 'Field is required';
                    },
                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },
                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },
                    isEmailAddress(v) {
                        return (v === null || v === '' || v === undefined) || (/^\S+@\S+$/).test(v.toString()) || 'Not a valid E-Mail Address.';
                    }
                },

                 // >>> ------------------------------------ 'Airport Contact Table'
				headersAirportContact: [
                    { text: 'Name', value: 'name', class: 'sticky-header grey lighten-3' },
					{ text: 'Role', value: 'role', class: 'sticky-header grey lighten-3' },
					{ text: 'E-Mail', value: 'email', class: 'sticky-header grey lighten-3' },
                    { text: 'Actions', value: 'actions', class: 'sticky-header grey lighten-3' }
				],
                // >>> ------------------------------------ 'Slot Contact Table'
				headersSlotContact: [
                    { text: 'Name', value: 'name', class: 'sticky-header grey lighten-3' },
					{ text: 'E-Mail', value: 'email', class: 'sticky-header grey lighten-3' },
                    { text: 'Actions', value: 'actions', class: 'sticky-header grey lighten-3' }
				]
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Countries'
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {

                    const me = this,
                          eventRecord = me.airportsPrefillObject;


                    me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (me.value === true) { // we're opening so initialize data

                        // >>> ------------------ reset validation
                        if (me.$refs.form !== undefined) {
                            me.$refs.form.resetValidation();
                        }

                        // >>> ------------------ update
                        if (me.editorMode === 'update') {
                            if (eventRecord) {
                                me.onAssign_Update(eventRecord);
                            }
                        }

                        // >>> ------------------ create
                        if (me.editorMode === 'create') {
                            me.onAssign_Create();

                        }

                    }

                    return this.value;

                }, // eo function sheetShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    me.formStepper = 1;
                    me.$emit('input', value);

                } // eo function sheetShown set()

            } // eo function sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> created');
            eventBus.$on('airportwasupdatedcreated', this.onEmit_AirportWasUpdatedCreated);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> destroyed');
            eventBus.$off('airportwasupdatedcreated', this.onEmit_AirportWasUpdatedCreated);

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getAirports',
                'actn_call_updateCreateAirports'
            ]),


            /*******************************************************************
            * Listeners: Common
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form{}
            *
            * Desc:
            * Note:
            *
            */
            onValidate_Form: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onValidate_Form');
                me.validateFormStepper('1');
                me.validateFormStepper('2');
                me.validateFormStepper('3');

                if (me.$refs.form.validate() === true) {
                    payload = me.createPayload();

                    me.actn_call_updateCreateAirports(payload);
                }

            }, // eo function onValidate_Form()


            /*******************************************************************
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'create' Mode. (Reset)
            * Note:
            *
            */
            onAssign_Create: function() {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    id: null,
                    isSlotContactUpdateCase: false,
                    isAirportContactUpdateCase: false,
                    input_airportName: '',
                    input_airportNameDE: '', // just a translation? no extra field current
                    input_iataCode: '',
                    input_icaoCode: '',
                    input_country: '',
                    input_airportWebsite: '',
                    input_latitude: null,
                    input_longitude: null,
                    // >>> General Time ---------------------------
                    input_timeZoneName: '',
                    input_AirportOpenFrom: '',
                    input_AirportOpenTill: '',
                    // >>> Airport Contact ------------------------
                    input_airportContacts: [],
                    input_contactId: null,
                    input_contactName: '',
                    input_contactRole: '',
                    input_contactEmail: '',
                    // >>> Slot Info ------------------------------
                    input_AirportCoordinated: {
                        text: 'No',
                        value: false
                    },
                    input_AirportCoordinationLevel: null,
                    input_slotContacts: [],
                    input_slotId: null,
                    input_slotName: '',
                    input_slotEmail: '',
                    // // >>> Validation ------------------------------------------
                    valid: true,
                    isValid_Stepper1: true,
                    isValid_Stepper2: true,
                    isValid_Stepper3: true,
                    activeStepper: '1'
                });

            }, // eo function onAssign_Create()


            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note: Airport Fields need to be updated, after setting.
            * Note: There is a whole object needed, not just the plain IATA Code
            * Note: String. (This could be done since we set these iata codes
            * Note: based on the backends answer.)
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> General ------------------------------
                    id: eventRecord.id,
                    isSlotContactUpdateCase: false,
                    isAirportContactUpdateCase: false,
                    input_airportNameDE: eventRecord.airportNameDE,
                    input_airportName: eventRecord.airportName, // just a translation? no extra field current
                    input_iataCode: eventRecord.iataCode,
                    input_icaoCode: eventRecord.icaoCode,
                    input_country: eventRecord.idCountry,
                    input_airportWebsite: eventRecord.website,
                    input_latitude: eventRecord.latitude,
                    input_longitude: eventRecord.longitude,
                    input_location: eventRecord.location,
                    input_locationDE: eventRecord.locationDE,
                    // >>> General Time ---------------------------
                    input_timeZoneName: eventRecord.timeZoneName,
                    input_AirportOpenFrom: eventRecord.openingHoursFrom,
                    input_AirportOpenTill: eventRecord.openingHoursTo,
                    // >>> Airport Contact ------------------------
                    input_airportContacts: eventRecord.airportContacts,
                    input_contactId: null,
                    input_contactName: '',
                    input_contactRole: '',
                    input_contactEmail: '',
                    // >>> Slot Info ------------------------------
                    input_AirportCoordinated: eventRecord.coordinated ? {
                        text: 'Yes',
                        value: true
                    } : {
                        text: 'No',
                        value: false
                    },
                    input_AirportCoordinationLevel: me.items_AirportCoordinationLevel.find(item => item.value === eventRecord.coordinationLevel),
                    input_slotContacts: eventRecord.slotContacts,
                    input_slotId: null,
                    input_slotName: '',
                    input_slotEmail: '',
                    // >>> Validation ------------------------------------------
                    valid: true,
                    isValid_Stepper1: true,
                    isValid_Stepper2: true,
                    isValid_Stepper3: true,
                    activeStepper: '1'
                });

            }, // eo function onAssign_Update()


            /*******************************************************************
            * onValidate_AirportContact()
            *
            * Desc: Check if Airport Contact Form is valid.
            *   Problem:
            *       1. Create slotContact id === null
            *       2. We don't safe the contact into backend but want to edit it
            *       3. id is still null so we cant find the correct contact to update (other values to find are not possible becuase we can change them manually)
            *   Solution:
            *       1. We create a tmp_id to identify the correct contact to update
            *       2. After identifing the contact we then overwrite the tmp_id again to null
            *
            */
            onValidate_AirportContact: function() {

                const me = this,
                      tmp_id = (Math.floor(Math.random() * 10000) * -1);
                let payload = null,
                    loadedAirportContacts = [];


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onValidate_AirportContact');
                me.validateFormStepper('2');

                if (me.$refs.form.validate() === true) {

                    loadedAirportContacts = JSON.parse(JSON.stringify(me.input_airportContacts));

                    payload = {
                        email: me.input_contactEmail,
                        idAirport: me.id,
                        id: me.input_contactId ? me.input_contactId : tmp_id,
                        name: me.input_contactName,
                        role: me.input_contactRole
                    };

                    // create case
                    if (me.isAirportContactUpdateCase === false) {
                        loadedAirportContacts.push(payload);
                    }


                    // update case
                    if (me.isAirportContactUpdateCase === true) {

                        loadedAirportContacts = loadedAirportContacts.map((airportContact) => {
                            // overwrite existing slot contact entry
                            if (airportContact.id === me.input_contactId) {
                                airportContact = payload;
                            }
                            return airportContact;
                        });
                    }

                    me.input_airportContacts = loadedAirportContacts; // set new airport contacts
                    me.isAirportContactUpdateCase = false; // reset
                    me.input_contactId = null; // reset
                    me.input_contactEmail = ''; // reset
                    me.input_contactName = ''; // reset
                    me.input_contactRole = ''; // reset
                }

            }, // eo function onValidate_AirportContact()


            /*******************************************************************
            * onValidate_SlotContact()
            *
            * Desc: Check if Slot Contact Form is valid.
            * Note: Create Random ID for freshly created slotContact (id currently null but we need to edit it -> so create new random id)
            *   Problem:
            *   1. Create slotContact id === null
            *   2. We don't safe the contact into backend but want to edit it
            *   3. id is still null so we cant find the correct contact to update (other values to find are not possible becuase we can change them manually)
            *   Solution:
            *   1. We create a tmp_id to identify the correct contact to update
            *
            */
            onValidate_SlotContact: function() {

                const me = this,
                      tmp_id = (Math.floor(Math.random() * 10000) * -1);
                let payload = null,
                    loadedSlotContacts = [];


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onValidate_SlotContact');
                me.validateFormStepper('2');

                if (me.$refs.form.validate() === true) {

                    loadedSlotContacts = JSON.parse(JSON.stringify(me.input_slotContacts));

                    payload = {
                        email: me.input_slotEmail,
                        idAirport: me.id,
                        id: me.input_slotId ? me.input_slotId : tmp_id, // set tmp_id if slotId === null (new created contact)
                        name: me.input_slotName
                    };

                    // create case
                    if (me.isSlotContactUpdateCase === false) {
                        loadedSlotContacts.push(payload);
                    }

                    // update case
                    if (me.isSlotContactUpdateCase === true) {

                        loadedSlotContacts = loadedSlotContacts.map((slotContact) => {
                            // overwrite existing slot contact entry
                            if (slotContact.id === me.input_slotId) {
                                slotContact = payload;
                            }
                            return slotContact;
                        });
                    }

                    me.input_slotContacts = loadedSlotContacts; // set new slot contacts
                    me.isSlotContactUpdateCase = false; // reset
                    me.input_slotId = null; // reset
                    me.input_slotEmail = ''; // reset
                    me.input_slotName = ''; // reset
                    me.input_slotRole = ''; // reset
                }

            }, // eo function onValidate_SlotContact()


            /*******************************************************************
            * onClick_updateOrDeleteAirportContactEntry()
            *
            * Desc: Delets Contact
            * Note:
            *
            */
            onClick_updateOrDeleteAirportContactEntry: function(item, deleteOrUpdate) {

                const me = this;
                let loadedAirportContacts = [];


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onClick_updateOrDeleteAirportContactEntry');
                loadedAirportContacts = JSON.parse(JSON.stringify(me.input_airportContacts));

                if (deleteOrUpdate === 'delete') {
                    for (let i = 0; i < loadedAirportContacts.length; i++) {
                        if (loadedAirportContacts[i].id === item.id) {
                            loadedAirportContacts.splice(i, 1);
                            me.input_airportContacts = loadedAirportContacts;
                        }
                    }
                }

                if (deleteOrUpdate === 'update') {
                    me.isAirportContactUpdateCase = true;
                    me.input_contactId = item.id; // if not saved in the backend item.id === null
                    me.input_contactName = item.name;
                    me.input_contactRole = item.role;
                    me.input_contactEmail = item.email;

                }

            }, //eo function onClick_updateOrDeleteAirportContactEntry()


            /*******************************************************************
            * onClick_updateOrDeleteSlotContactEntry()
            *
            * Desc: Delets Contact
            * Note:
            *
            */
            onClick_updateOrDeleteSlotContactEntry: function(item, deleteOrUpdate) {

                const me = this;
                let loadedSlotContacts = [];


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onClick_updateOrDeleteSlotContactEntry');
                loadedSlotContacts = JSON.parse(JSON.stringify(me.input_slotContacts));

                if (deleteOrUpdate === 'delete') {
                    for (let i = 0; i < loadedSlotContacts.length; i++) {
                        if (loadedSlotContacts[i].id === item.id) {
                            loadedSlotContacts.splice(i, 1);
                            me.input_slotContacts = loadedSlotContacts;
                        }
                    }
                }

                if (deleteOrUpdate === 'update') {
                    me.isSlotContactUpdateCase = true;
                    me.input_slotId = item.id; // if not saved in the backend item.id === null
                    me.input_slotName = item.name;
                    me.input_slotEmail = item.email;
                }

            }, // eo function onClick_updateOrDeleteSlotContactEntry()


            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onClick_CloseSheet');
                me.sheetShown = false;

            }, // eo function onClick_CloseSheet{}




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * createPayload()
            *
            * Desc:
            * Note: id = null means create mode, id != null means update mode
            * Note: currently only create mode considered
            *
            * @returns {Object}
            */
            createPayload: function() {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> createPayload');
                // set back id to null (case if contact is added and edited but not safed in backend)
                me.input_airportContacts.forEach((airportContact) => {
                    if (airportContact.id < 0) {
                        airportContact.id = null;
                    }
                });
                // set back id to null (case if contact is added and edited but not safed in backend)
                me.input_slotContacts.forEach((slotContact) => {
                    if (slotContact.id < 0) {
                        slotContact.id = null;
                    }
                });

                return {
                    // >>> General ------------------------------
                    id: me.id,
                    airportName: me.input_airportName,
                    airportNameDE: me.input_airportName, // just a translation? no extra field current
                    iataCode: me.input_iataCode,
                    icaoCode: me.input_icaoCode,
                    idCountry: me.input_country,

                    location: me.input_location,
                    locationDE: me.input_location, // just a translation? no extra field current TODO: string

                    website: me.input_airportWebsite,
                    latitude: me.input_latitude,
                    longitude: me.input_longitude,
                    // >>> General Time ---------------------------
                    timeZoneName: me.input_timeZoneName,
                    openingHoursFrom: me.input_AirportOpenFrom,
                    openingHoursTo: me.input_AirportOpenTill,
                    // >>> Airport Contact ------------------------
                    airportContacts: me.input_airportContacts,
                    // >>> Slot Info ------------------------------
                    coordinated: me.input_AirportCoordinated.value,
                    coordinationLevel: me.input_AirportCoordinationLevel ? me.input_AirportCoordinationLevel.value : null,
                    slotContacts: me.input_slotContacts
                };

            }, // eo function createPayload()



            /*******************************************************************
            * Listeners/ Utilities: Stepper Validation
            *******************************************************************/
            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            * @param {Number} stepperNumber
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onClick_StepperHeader');
                switch (me.activeStepper) {
                    case '1':
                        if (me.isValid_Stepper1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    case '2':
                        if (me.isValid_Stepper2 === false) {
                            me.validateFormStepper('2');
                        }
                        break;
                    case '3':
                        if (me.isValid_Stepper3 === false) {
                            me.validateFormStepper('3');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            }, // eo function onClick_StepperHeader()


            /*******************************************************************
            * validateInputFields()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Boolean}
            */
            validateInputFields: function(element) {

                const me = this;
                let valid = true;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> validateInputFields');
                if ('type' in element) { // ;-)
                    return element.valid !== undefined ? element.valid : true;
                } else {
                    if (element.$children.length > 0) {
                        element.$children.forEach(child => {
                            valid = valid && this.validateInputFields(child);
                        });
                    }
                }

                return valid;

            }, // eo function validateInputFields()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                const me = this;
                let stepperIsValid = true,
                    child = null,
                    stepperRef = null;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> validateFormStepper');
                switch (stepperNumber) {
                    case '1':
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    case '2':
                        stepperRef = this.$refs.stepperContent2;
                        break;
                    case '3':
                        stepperRef = this.$refs.stepperContent3;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }


                if (stepperRef !== null) {
                    for (let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        stepperIsValid = this.validateInputFields(child);
                        stepperIsValid = false;
                        break;
                    }
                }


                switch (stepperNumber) {
                    case '1':
                        this.isValid_Stepper1 = stepperIsValid;
                        break;
                    case '2':
                        this.isValid_Stepper2 = stepperIsValid;
                        break;
                    case '3':
                        this.isValid_Stepper3 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            }, // eo function validateFormStepper()


            /*******************************************************************
            * onChange_airportCoordinated()
            *
            * Desc:
            * Note:
            *
            */
            onChange_airportCoordinated: function(value) {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onChange_airportCoordinated');
                if (value.value === false) {
                    me.input_AirportCoordinationLevel = null;
                }

            }, // eo function validateFormStepper()


            /*******************************************************************
            * onEmit_AirportWasUpdatedCreated()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_AirportWasUpdatedCreated: function() {

                const me = this;


                me.$toc('>>> views/flights/airports/components/core/BottomSheet.vue >>> onEmit_AirportWasUpdatedCreated');
                me.onClick_CloseSheet();

            } // eo function onEmit_AirportWasUpdatedCreated{()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }
</style>
